<div class="container my-4 px-0 d-flex flex-column w-100">
    <app-merchant-account-list [merchantAccounts]="merchantAccounts" headingText="Merchant Accounts" [isAdmin]="true"></app-merchant-account-list>
</div>
